import { render, staticRenderFns } from "./WidgetProductReviewsStatisticsMobile.vue?vue&type=template&id=f34f5d86&scoped=true"
import script from "./WidgetProductReviewsStatisticsMobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsStatisticsMobile.vue?vue&type=script&lang=js"
import style0 from "./WidgetProductReviewsStatisticsMobile.vue?vue&type=style&index=0&id=f34f5d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34f5d86",
  null
  
)

export default component.exports